module.exports = __webpack_public_path__ + "static/media/sidebar-2.61e8754d.jpg";